import React from 'react'
import ShapeAnimation from '../../ShapeAnimation'
import { Link } from 'react-router-dom';
const AboutBanner = () => {
    return (
        <>
            {/* <div className="about-banner">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container"></div>
                    </div>
                </div>
                <ShapeAnimation />
            </div> */}
            <div className="bread-internal-cls">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/services">Services</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                About Us
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <div className="container">
                <div className="intro-video">
                    <iframe className='w-100' height={515} poster='./assets/about-us-baner.webp' src="https://www.youtube.com/embed/QvYgBXb50bs?si=SP39oSuEVnAStz0Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    {/* <img src="./assets/about-us-baner.webp" className='img-fluid' alt="" /> */}
                    {/* <img src="./assets/play.webp" className='img-fluid' alt="" /> */}
                    {/* <video width="400" height="350" controls poster="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20190710102234/download3.png">
                        <source src="https://media.geeksforgeeks.org/wp-content/uploads/20200409094356/Placement100-_-GeeksforGeeks2.mp4"
                            type="video/mp4" />
                    </video> */}
                </div>
            </div>

        </>
    )
}

export default AboutBanner